<template>
  <v-chip
    v-if="(typeof param === 'object' && param !== null && (!!param.def || param.real !== null && param.real !== undefined)) || (typeof param !== 'object' && param)"
    :small="!dense"
    :x-small="dense"
    class="mr-1"
    label
  >
    <strong class="mr-2">{{ label }}:</strong>

    <span v-if="forceValue">
      {{ forceValue }}
    </span>

    <span
      v-else-if="param.real !== null && param.real !== undefined && !param.def"
      class="ml-1 success--text"
    >
      {{ getConvertedParam(param.real, suffix) }}
    </span>

    <span v-else>
      <span
        :class="{ 'grey--text text-decoration-line-through': param.real !== null && param.real !== undefined && param.def && param.real !== param.def }"
      >
        {{ getConvertedParam(param, suffix) }}
      </span>
      <span
        v-if="param.real !== null && param.real !== undefined && param.def && param.real !== param.def"
        class="ml-1"
        :class="{ 'error--text': param.real < param.def, 'success--text': param.real > param.def}"
      >
        {{ getConvertedParam(param.real, suffix) }}
      </span>
    </span>
  </v-chip>
</template>

<script>

export default {
  name: 'ExerciseParamLabelHelper',
  props: {
    param: {
      type: [String, Object, Number, Boolean],
      default: () => null
    },
    suffix: {
      type: String,
      default: ''
    },
    dense: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      required: true
    },
    forceValue: {
      type: String,
      default: ''
    }
  },
  computed: {
    user() {
      return this.$store.getters[this.$storeGetters.AUTH_USER]
    },
    isImperial() {
      return this.user?.organisation_settings?.unit_system === 'imperial'
    }
  },
  methods: {
    getConvertedParam(param, suffix) {
      const value = (typeof param === 'object' && 'def' in param) ? param.def : param

      if (suffix === 's' && value >= 60) {
        let minutes = Math.floor(value / 60) + 'min'
        if (Math.floor(value % 60) > 0) minutes += ' ' + Math.floor(value % 60) + 's'
        return minutes
      } else if (suffix === 'm' && value >= 1000) {
        if (this.isImperial) {
          const totalFeet = value / 0.3048
          const miles = Math.floor(value / 1609.34)
          const remainingFeet = Math.floor(totalFeet - (miles * 5280))
          let result = ''
          if (miles > 0) result += miles + 'mi'
          if (remainingFeet > 0) result += (result ? ' ' : '') + remainingFeet + 'ft'
          return result
        } else {
          let kilometers = Math.floor(value / 1000) + 'km'
          if (Math.floor(value % 1000) > 0) kilometers += ' ' + Math.floor(value % 1000) + 'm'
          return kilometers
        }
      } else if (suffix === 'm') {
        if (this.isImperial) {
          const feet = Math.floor(value / 0.3048)
          return feet + 'ft'
        } else {
          return value + 'm'
        }
      } else {
        return value + suffix
      }
    }
  }
}
</script>
